import React from 'react';
import { Box, Typography, Button, Paper, Alert } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { Lock as LockIcon } from '@mui/icons-material';
import { useApplicationManager } from '../../contexts/ApplicationManagerContext';
import { VERDE_MENTA, FUNDO_PAPEL, TEXTO_PRIMARIO } from '../../themes/themeConstants';

const AccessDeniedPage: React.FC = () => {
  const navigate = useNavigate();
  const { user, userRoles } = useApplicationManager();

  const hasRole = (role: string) => {
    return userRoles.some(ur => ur.papel?.nome === role && ur.ativo);
  };

  const handleGoBack = () => {
    // Redirecionar baseado nos papéis RBAC
    if (hasRole('super_admin') || hasRole('platform_admin')) {
      navigate('/super-admin/dashboard');
    } else if (hasRole('project_owner') || hasRole('project_admin')) {
      navigate('/owner/dashboard');
    } else if (hasRole('project_user') || hasRole('project_viewer')) {
      navigate('/owner/dashboard');
    } else if (user) {
      navigate('/owner/dashboard'); // Fallback para usuários autenticados
    } else {
      navigate('/login');
    }
  };

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        minHeight: '100vh',
        backgroundColor: FUNDO_PAPEL,
        p: 3,
      }}
    >
      <Paper
        elevation={3}
        sx={{
          p: 4,
          textAlign: 'center',
          maxWidth: 500,
          backgroundColor: FUNDO_PAPEL,
          border: `1px solid ${VERDE_MENTA}30`,
        }}
      >
        <LockIcon
          sx={{
            fontSize: 64,
            color: 'error.main',
            mb: 2,
          }}
        />
        
        <Typography
          variant="h4"
          sx={{
            color: TEXTO_PRIMARIO,
            mb: 2,
            fontWeight: 600,
          }}
        >
          Acesso Negado
        </Typography>
        
        <Typography
          variant="body1"
          sx={{
            color: TEXTO_PRIMARIO,
            mb: 3,
            opacity: 0.8,
          }}
        >
          Você não tem permissão para acessar esta página.
        </Typography>

        {user && (
          <Alert 
            severity="info" 
            sx={{ 
              mb: 3,
              backgroundColor: `${VERDE_MENTA}20`,
              color: TEXTO_PRIMARIO,
              '& .MuiAlert-icon': { color: VERDE_MENTA }
            }}
          >
            <Typography variant="body2">
              <strong>Usuário:</strong> {user.email}
            </Typography>
            <Typography variant="body2">
              <strong>Papéis:</strong> {userRoles.map(ur => ur.papel?.nome).join(', ') || 'Nenhum'}
            </Typography>
          </Alert>
        )}

        <Button
          variant="contained"
          onClick={handleGoBack}
          sx={{
            backgroundColor: VERDE_MENTA,
            color: 'white',
            px: 4,
            py: 1.5,
            '&:hover': {
              backgroundColor: '#00A693',
            },
          }}
        >
          {user ? 'Voltar ao Dashboard' : 'Ir para Login'}
        </Button>
      </Paper>
    </Box>
  );
};

export default AccessDeniedPage;